import React, { useEffect, useState } from "react";
import { CardText } from "reactstrap";
import "assets/scss/website/app.scss";
import Select from "react-select";
import "react-rangeslider/lib/index.css";
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import "react-multi-carousel/lib/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters, resetFilters } from "store/filter/actions";
import "./styles.scss";
const arr = [2, 3, 4, 5, 6];
const RoomFilter = ({ roomsType, showLoading }) => {
	const filterData = useSelector((state) => state.filter);
	const dispatch = useDispatch();

	return (
		<>
			{arr.map((itemaData, index) => {
				return (
					<span key={index}>
						<input
							type="checkbox"
							className="btn-check"
							name="room"
							id={`room${itemaData}`}
							autoComplete="off"
							checked={filterData[`${roomsType}`].some(
								(item) => item === itemaData
							)}
							onChange={() => {}}
						/>
						<label
							onClick={() => {
								const isExist = filterData[`${roomsType}`].some(
									(item) => item === itemaData
								);
								if (itemaData === 6) {
									if (!isExist) {
										dispatch(appendFilters({ [`${roomsType}`]: [itemaData] }));
										showLoading();
									} else {
										const updatedData = filterData[`${roomsType}`].filter(
											(item) => item !== itemaData
										);
										dispatch(
											appendFilters({ [`${roomsType}`]: [...updatedData] })
										);
										showLoading();
									}
								} else {
									if (!isExist) {
										const updatedArray = filterData[`${roomsType}`].filter(
											(item) => item != 6
										);
										dispatch(
											appendFilters({
												[`${roomsType}`]: [...updatedArray, itemaData],
											})
										);
										showLoading();
									} else {
										const updatedData = filterData[`${roomsType}`].filter(
											(item) => item !== itemaData
										);
										dispatch(
											appendFilters({ [`${roomsType}`]: [...updatedData] })
										);
										showLoading();
									}
								}
							}}
							className={`btn btn-outline-light mb-0 ${
								filterData[`${roomsType}`].some((item) => item === itemaData)
									? "active"
									: ""
							}`}
							htmlFor="btncheckType">
							{itemaData != 6 ? itemaData : `+${itemaData}`}
						</label>
					</span>
				);
			})}
		</>
	);
};

export default RoomFilter;
